import { Link } from "react-router-dom";
import type { Comic } from "@/mocks/comics";

export default function ComicCard({ comic }: { comic: Comic }) {
  const isOngoing = comic.status === "连载中";
  return (
    <Link
      to={`/comic/${comic.id}`}
      className="group overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
    >
      <div className="relative aspect-[4/5] w-full overflow-hidden">
        <img
          src={comic.cover}
          alt={`${comic.title}封面 更新到第${comic.latestChapter}话`}
          title={`${comic.title} 追更进度查询`}
          className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105"
        />
        <span
          className={`absolute left-2 top-2 rounded-full px-2 py-0.5 text-xs font-medium text-background-50 ${
            isOngoing ? "bg-primary-500" : "bg-accent-500"
          }`}
        >
          {comic.status}
        </span>
        <span className="absolute right-2 top-2 rounded-full bg-background-950/60 px-2 py-0.5 text-xs text-background-50 backdrop-blur-sm">
          第{comic.latestChapter}话
        </span>
      </div>
      <div className="p-3 md:p-4">
        <h3 className="truncate text-sm font-semibold text-foreground-950 group-hover:text-primary-600 md:text-base">
          {comic.title}
        </h3>
        <p className="mt-1 text-xs text-secondary-600 md:text-sm">
          {isOngoing ? `更新到第${comic.latestChapter}话` : `全${comic.totalChapters}话完结`}
        </p>
        <div className="mt-3 flex items-center justify-between text-xs text-foreground-600">
          <span className="flex items-center gap-1">
            <i className="ri-history-line"></i>
            {comic.updateTime}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-eye-line"></i>
            {comic.views >= 10000 ? `${(comic.views / 10000).toFixed(1)}w` : comic.views}
          </span>
        </div>
      </div>
    </Link>
  );
}